import React, { ComponentType } from 'react'

export interface TickarooWidgetProps {
  clientId: string
  liveBlogId: string
  layout?: 'timeline' | 'masonry' | 'default'
}

const TickarooTickerWidget: ComponentType<TickarooWidgetProps> = ({
  clientId,
  liveBlogId,
  layout = 'timeline'
}) => {
  const params = {
    id: 'tickaroo-liveblog',
    liveblogId: liveBlogId,
    clientId: clientId,
    showWebEmbeds: 'consent_handling',
    locale: 'de',
    blacklistedScoreboardAffiliations: 'Tik::ApiModel::LiveRef',
    showLineup: true,
    layout,
    layoutAuthorPosition: 'off'
  }

  return <tickaroo-liveblog {...params}></tickaroo-liveblog>
}

export default TickarooTickerWidget
